"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * Displays a column of vertical tabs, usually appears on the left side of a page.
 */
const VerticalTabs = ({ links, width = '8' }) => !!(links && links.length) ? (react_1.default.createElement("div", { className: `ma-6 w-${width}` }, links.map(({ href, isHeading, isActive, onClick, title }, index) => {
    let className = 'block no-underline pv-4 mv-2 ';
    const isClickable = href || onClick;
    if (isClickable) {
        className += 'cursor-pointer ';
    }
    if (isHeading) {
        className += 'b gray4';
    }
    else {
        className += 'ph-6 bo-radius-2 ';
        if (isActive) {
            className += 'bg-blue1 blue4 b';
        }
        else {
            className += 'gray4 ';
            if (isClickable) {
                className += 'hover-blue4';
            }
        }
    }
    return isClickable ? (react_1.default.createElement("a", { key: index, href: href, onClick: onClick, className: className }, title)) : (react_1.default.createElement("span", { key: index, className: className }, title));
}))) : (react_1.default.createElement("div", null));
exports.default = VerticalTabs;
